// extracted by mini-css-extract-plugin
export default {"cls1":"k_LQ3GXcWGPMuuOy2zFk","cls2":"lATROxp_wOkBWVaewUC0 k_LQ3GXcWGPMuuOy2zFk","isPhone":"TWDG6CFTtKuqidqlqSgu"};